import { FCWithChildren } from '@types';
import React, { useState } from 'react';
import { ModalVerificationRegister } from '@components';
import useLayoutContext from '@hooks/useLayoutContext';
import { Redirect, useHistory } from 'react-router-dom';
import usePageTitle from '@hooks/usePageTitle';
import { useMutation } from '@tanstack/react-query';
import { verificationRegister } from 'sdk-apogee/lib/user';
import { getSubdomain } from '@utils';

type PlaceHolderProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export type IVerificationFormData = {
  email: string;
  termsAndConditions?: boolean;
};

const subdomain = getSubdomain();

const VerificationRegister: FCWithChildren<PlaceHolderProps> = () => {
  usePageTitle('Email Verification');
  const { testCaptiveMac: mac } = useLayoutContext();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(true);
  const { mutate, isPending, error } = useMutation({
    mutationFn: (email: string) => verificationRegister({ subdomain, mac, email }),
    onSuccess: async () => {
      history.push('/verification/check-email');
    },
  });

  const onClose = () => {
    setIsOpen(false);
  };

  const onConfirm = (formData: IVerificationFormData) => {
    const { termsAndConditions, ...data } = formData;
    mutate(data.email);
  };

  return !mac ? (
    <Redirect to={'/'} />
  ) : (
    <ModalVerificationRegister
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={isPending}
      error={error}
    />
  );
};

export default VerificationRegister;
